import router from "src/router";
import appConsoleService from "src/services/utils/appConsoleService";
import {useLayoutStore} from "stores/layoutStore";

class NavigationService {


  /**
   * Options :
   * String : navigation depends on a path
   * Json : navigation depends on name and params
   * @param options
   * @returns {Promise<void>}
   */
  async push(options, updateBackRoute = undefined) {
    try {
      await router.push(options)

      let layoutStore = useLayoutStore()
      if(updateBackRoute) {
        layoutStore.setBackRoute(updateBackRoute)
      }
      else {
        layoutStore.resetBackRoute()
      }
      
      appConsoleService.info('navigationService','Navigation with ' + JSON.stringify(options))
    } catch(error) {
      console.error(error)
    }
  }

  async pushTo(path) {
    await this.push(path);
  }

  async goToHome() {
    await this.push("/")
  }

  async goToLogin() {
    await this.push("/Login")
  }

  async goToDashBoard() {
    await this.push("/DashBoard")
  }

  /** Après la connexion : le tableau de bord remplace la page de connexion dans l'historique (le retour n'y ramène pas) */
  async replaceWithDashBoard() {
    try {
      await router.replace("/DashBoard")
      useLayoutStore().resetBackRoute()
    } catch (error) {
      console.error(error)
    }
  }

  async goToDiagnosticDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "diagnostic-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToSystemDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "system-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }
  async goToGardenDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "garden-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToPlantDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "plant-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }


  async goToOilDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "oil-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToVegetableDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "vegetable-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToBourgeonDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "bourgeon-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToHydrolatDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "hydrolat-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)
  }

  async goToAdditionalDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "additional-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)
  }

  async goToPhytoDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "phyto-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToAromaDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "aroma-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)
   
  }

  async goToGemmoDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "gemmo-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)
  }

  async goToHuiloDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "huilo-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)
  }

  async goToMixDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "mix-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }

  async goToCheckDetail(id, updateBackRoute = undefined) {
    let options = {
      name: "check-detail",
      params: { id: id },
    }
    await this.push(options, updateBackRoute)

  }


  openArtworkLink(ercBase) {
    let link = window.location.origin + "/artwork/"+ ercBase.address+"/"+ ercBase.tokenId //AppConvertService.appConvert(ercBase.edition_name)
    window.open(link, "_blank");
  }

  openExternalLink(url) {
    window.open(url, "_blank");
  }

  openSelf(url) {
    window.open(url, "_self");
  }

  async goBack() {
    let layoutStore = useLayoutStore()
    if(layoutStore.getBackRoute){
      let options = layoutStore.getBackRoute
      await this.push(options)
      layoutStore.resetBackRoute()
    }
    else {
      router.back()
    }

  }
}

export default new NavigationService()
